import { render } from "./SqlServerLogoIcon.vue?vue&type=template&id=d52e0cf0"
import script from "./SqlServerLogoIcon.vue?vue&type=script&lang=js"
export * from "./SqlServerLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__